<template>
  <div>
    <div class="chappeanim">
      <div class="chappeanim-body"></div>
      <div class="chappeanim-arm" ref="arm">
        <div class="chappeanim-arm-sub" ref="armleft"></div>
        <div class="chappeanim-arm-sub" ref="armright"></div>
      </div>
    </div>
    <PlayerControls :playing="playing" :progress="progress" @toggle="togglePlay" @reset="resetPlay" />
  </div>
</template>

<script>
import PlayerControls from "@/components/layout/PlayerControls";

// arms rotations for each position possible
const positions = {
  start: [90, 0, 0],
  end: [0, 0, 0],
  n1: [0, 90, -90],
  n2: [90, -90, 0],
  n3: [0, 135, 0],
  n4: [90, 0, -90],
  n5: [0, 135, -45],
  n6: [90, -135, 135],
  n7: [90, 90, 90],
  n8: [0, -90, 0],
  n9: [90, 90, -90],
  n10: [0, 45, -45],
  n11: [90, 90, 0],
  n12: [0, -90, -90],
}
import gsap from "gsap"

export default {
  components: {PlayerControls},
  props: {
    steps: Array
  },
  data: () => ({
    playing: false,
    progress: 0
  }),
  mounted() {
    this.createTimeline()
  },
  watch: {
    steps() {
      this.progress = 0
      this.playing = false
      this.timeline && this.timeline.pause()
      this.createTimeline()
    }
  },
  methods: {
    // create gsap timeline that move arms according to current phrase steps
    createTimeline() {
      this.timeline = new gsap.timeline({
        paused: true,
        onComplete: () => {
          this.playing = false
        },
        onUpdate: () => {
          this.progress = this.timeline.progress()
        }
      })

      this.$refs.arm.style.transform = 'rotate('+positions.start[0]+'deg)'
      this.$refs.armleft.style.transform = 'rotate('+positions.start[1]+'deg)'
      this.$refs.armright.style.transform = 'rotate('+positions.start[2]+'deg)'

      let i = 0
      for(const step of this.steps) {
        const pos = positions[step]
        const duration = step === "start" ? 0 : 1
        const time = i === 0 ? 0 : i * 3 - 2.5
        this.timeline.to(this.$refs.arm, { rotation: pos[0], duration: duration }, time)
        this.timeline.to(this.$refs.armleft, { rotation: pos[1], duration: duration }, time)
        this.timeline.to(this.$refs.armright, { rotation: pos[2], duration: duration }, time)
        i++
      }
    },
    togglePlay() {
      this.playing = !this.playing
      if(this.playing) {
        if(this.progress === 1) {
          this.timeline.restart()
        } else {
          this.timeline.play()
        }
      } else {
        this.timeline.pause()
      }
    },
    resetPlay() {
      this.playing = true
      this.timeline.restart()
    }
  }
}
</script>

<style scoped lang="scss">
.chappeanim {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;

  &-body {
    position: absolute;
    width: 26px;
    height: 55%;
    bottom: 0;
    left: calc(50% - 13px);
    background-color: #CCC;
  }

  &-arm {
    position: absolute;
    width: 120px;
    height: 4px;
    top: 50%;
    left: calc(50% - 60px);
    background-color: #000;
    transform-origin: center;

    &:before, &:after {
      content: '';
      position: absolute;
      top: 50%;
      width: 10px;
      height: 10px;
      background-color: #000;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
    &:before {
      left: 0;
    }
    &:after {
      right: -10px;
    }

    &-sub {
      position: absolute;
      width: 70px;
      height: 4px;
      top: 0;
      background-color: #000;
      border-radius: 3px;

      &:first-child {
        right: 100%;
        transform-origin: right center;
      }
      &:last-child {
        left: 100%;
        transform-origin: left center;
      }
    }
  }
}
</style>